import React, { useState, useEffect, useContext, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import SearchDropDown from "../../../../ui-components/SearchDropDown";
// material-ui
import { Container, Paper, Typography, Grid, Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import AppContext from "../../../../context/Context";
import { isEmptyObject, timeToLocal, getLocalStorageObject, setLocalStorageObject } from "../../../../util/helper";
import { Radio, InputNumber, Switch } from "antd";
import MultiChartDropdown from '../MultiChartDropdown';
import {  quckAction } from "../../../../redux/actions/brokerAction";
  import { Card, Form, Button } from "react-bootstrap";

const exchange = "NSE";
 
  
const configs = {
 
  tagName:["BUTTON", "SELECT", "INPUT"]
};
// style constant
 
let localStorageScreenObj = getLocalStorageObject("chart") || {
  
  quikKeys:false,
  ohlc:false,
  chartScreenType:1,
  chartType:"CE"
};
const QuikKeysCom = () => {
  const {
    config: { isDark },
    setConfig,
  } = useContext(AppContext);
  const dispatch = useDispatch();
  const [hotkey, setHotkey] = useState(getLocalStorageObject("chart")?.quikKeys || false);
  const [splitScreen, setsplitScreen] = useState(getLocalStorageObject("chart")?.chartScreenType || 1);
  const [chartType, setchartType] = useState(getLocalStorageObject("chart")?.chartType || "CE");

  useEffect(() => {

     if(getLocalStorageObject("chart")?.chartType) {
       dispatch(quckAction(getLocalStorageObject("chart")));
     } else {
      chartTypeClick("CE");
     }
  },[])
  const shapeClick = (type) => {
   setsplitScreen(type)
   setLocalStorageObject(
       "chart",
       'chartScreenType',
       type,
       localStorageScreenObj
   );
      dispatch(quckAction(getLocalStorageObject("chart")));

      if(type == 2 || type == 3) {
        chartTypeClick("")
      }
  }

  const chartTypeClick = (type) => {
    setchartType(type)
    setLocalStorageObject(
        "chart",
        'chartType',
        type,
        localStorageScreenObj
    );
       dispatch(quckAction(getLocalStorageObject("chart")));
   }
 
  return (
    <>
       <input type="hidden" id="hotkey" value={hotkey}></input>
          {/* main dropdowns */}
        <div className="basket-action-header">
              <div className="group-sq">
                      <Grid item className="text-center me-1">
                        <Typography style={{  fontSize:"11px", marginTop:"3px"}}>QuikKeys </Typography>
                      </Grid> 
                      <Grid item className="text-center">
                        <Switch
                          checked={hotkey}
                          onChange={(e) => {
                            setHotkey(e);
                            setLocalStorageObject(
                                  "chart",
                                  'quikKeys',
                                  e,
                                  localStorageScreenObj
                                );
                            
                                dispatch(quckAction(getLocalStorageObject("chart")));
                          }}
                          size="small"
                        />
                      </Grid>
              </div>
              <div className="me-2">
              <MultiChartDropdown shapeClick={shapeClick} splitScreen={splitScreen} />

              </div>
              {splitScreen ===1 &&
                 <Grid item>
                  <Form.Group className="form-group">
                      <Form.Select aria-label="Default select example" name="chartType" value={chartType} onChange={(e)=>{chartTypeClick(e.target.value)}}>
                          {['CE','PE','Spot/Fut'].map((data, index) => {
                                      return (
                                          <option value={data} key={index}>{data}</option>  
                                      )
                              })
                          }
                      </Form.Select>
                  </Form.Group> 
                </Grid>
              }
        </div>
    </>
  );
};

export default QuikKeysCom;
